import React, { PureComponent } from 'react';
import { number, bool, string, func } from 'prop-types';
import classnames from 'classnames';
import Checkbox from '../Checkbox/Checkbox';
import './ListItem.scss';

export default class ListItem extends PureComponent {
    static propTypes = {
        className: string,
        value: string.isRequired,
        label: string.isRequired,
        count: number,
        checked: bool,
        onClick: func.isRequired,
        // TODO rename to checkboxComponent ?
        checkbox: func,
        color: string,
        iconItem: string,
        dataQa: string,
        disabled: bool,
    };

    static defaultProps = {
        disabled: false,
        className: null,
        count: 0,
        checked: false,
        checkbox: Checkbox,
        color: null,
        iconItem: null,
        dataQa: null,
    };

    handleRootClick = evt => {
        const { onClick, value } = this.props;
        if (onClick) {
            onClick(value, evt);
        }
    };

    render() {
        const {
            value,
            label,
            count,
            className,
            checkbox,
            checked,
            color,
            iconItem,
            disabled,
            dataQa,
        } = this.props;
        const rootClassnames = classnames('list-item', className, {
            'list-item--disabled': disabled,
        });

        const optionalProps = {};
        if (dataQa) {
            optionalProps['data-qa'] = dataQa;
        }

        return (
            <button
                className={rootClassnames}
                data-filter-value={value}
                {...optionalProps}
                onMouseDown={this.handleRootClick}
            >
                {React.createElement(checkbox, {
                    checked,
                    color,
                    dataQaPrefix: 'listItem',
                })}

                {iconItem && (
                    <i className={`filter__icon icon icon__${iconItem}`} />
                )}

                <span className="list-item__label" data-qa="listItemLabelElm">
                    {label}
                </span>

                {count !== null && (
                    <span
                        className="list-item__count"
                        data-qa="listItemCountElm"
                    >
                        {count}
                    </span>
                )}
            </button>
        );
    }
}
